<template>
	<BaseForm class="login-form" v-bind="forward" @submit="login">
		<h1 class="fs-32 lh-40 fw-800 text-center mb-24">Log In</h1>
		<TextField v-model="email" type="email" required>Email Address</TextField>
		<PasswordField v-model="password" class="mt-16" hint="current" required>Password</PasswordField>

		<template #footer>
			<button type="submit" :class="{'is-logging-in': isProcessing}" class="btn btn-green btn-large w-full">
				<span v-if="isProcessing" class="flex gap-8 color-gray op-5">
					<div class="spinner dark w-16 h-16"></div>
					Logging In
				</span>
				<span v-else>Log In</span>
			</button>
			<div class="flex-split mt-8 grow">
				<div v-if="showRememberMe" class="checkbox-v2">
					<input id="remember-me" type="checkbox" v-model="rememberMe">
					<label for="remember-me">Remember Me</label>
				</div>
				<router-link class="fs-14" :to="{ name: $routes.ForgotPassword.name }" v-if="showForgotPassword">
					Forgot Password?
				</router-link>
			</div>
		</template>
	</BaseForm>
</template>

<script>
import form from '@/mixins/form';

export default {
	name: 'LoginForm',
	mixins: [form],
	props: {
		showForgotPassword: {
			type: Boolean,
			default: true,
		},
		showRememberMe: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		const rememberedEmail = localStorage.getItem('loginEmail');
		return {
			email: rememberedEmail || '',
			password: '',
			rememberMe: !!rememberedEmail,
			isProcessing: false,
		};
	},
	methods: {
		handleApiError(error, resolve, statusCode, messages) {
			this.isProcessing = false;
			if (statusCode === 401) {
				messages = 'Your email address or password is incorrect.';
			}
			this.errorMessage = messages;
		},
		login() {
			this.isProcessing = true;
			this.action('auth/login', {
				email: this.email,
				password: this.password,
				rememberMe: this.rememberMe,
			}).then(() => {
				this.$emit('login');
			});
		},
	},
};
</script>

<style lang="scss">
.login-form .form-footer {
	margin-top: 24px;
}

.btn.is-logging-in {
	background-color: #F3F2F6;
	border-color: #F3F2F6;
	cursor: progress;

	&:hover:not(:disabled),
	&:focus:not(:disabled) {
		background-color: #F3F2F6;
		border-color: #F3F2F6;
	}
}
</style>